/* eslint-disable */
export const maxLifetime = 86

export default [
[ 0, 1000 ],
[ 1, 679 ],
[ 2, 557 ],
[ 3, 457 ],
[ 4, 374 ],
[ 5, 307 ],
[ 6, 252 ],
[ 7, 206 ],
[ 8, 169 ],
[ 9, 159 ],
[ 10, 149 ],
[ 11, 139 ],
[ 12, 130 ],
[ 13, 122 ],
[ 14, 115 ],
[ 15, 107 ],
[ 16, 101 ],
[ 17, 94 ],
[ 18, 88 ],
[ 19, 83 ],
[ 20, 78 ],
[ 21, 73 ],
[ 22, 68 ],
[ 23, 64 ],
[ 24, 60 ],
[ 25, 56 ],
[ 26, 52 ],
[ 27, 49 ],
[ 28, 46 ],
[ 29, 43 ],
[ 30, 40 ],
[ 31, 38 ],
[ 32, 36 ],
[ 33, 33 ],
[ 34, 31 ],
[ 35, 29 ],
[ 36, 27 ],
[ 37, 26 ],
[ 38, 24 ],
[ 39, 23 ],
[ 40, 21 ],
[ 41, 20 ],
[ 42, 19 ],
[ 43, 17 ],
[ 44, 16 ],
[ 45, 15 ],
[ 46, 14 ],
[ 47, 13 ],
[ 48, 13 ],
[ 49, 12 ],
[ 50, 11 ],
[ 51, 10 ],
[ 52, 10 ],
[ 53, 9 ],
[ 54, 8 ],
[ 55, 8 ],
[ 56, 7 ],
[ 57, 7 ],
[ 58, 7 ],
[ 59, 6 ],
[ 60, 6 ],
[ 61, 5 ],
[ 62, 5 ],
[ 63, 5 ],
[ 64, 4 ],
[ 65, 4 ],
[ 66, 4 ],
[ 67, 4 ],
[ 68, 3 ],
[ 69, 3 ],
[ 70, 3 ],
[ 71, 3 ],
[ 72, 3 ],
[ 73, 2 ],
[ 74, 2 ],
[ 75, 2 ],
[ 76, 2 ],
[ 77, 2 ],
[ 78, 2 ],
[ 79, 2 ],
[ 80, 2 ],
[ 81, 1 ],
[ 82, 1 ],
[ 83, 1 ],
[ 84, 1 ],
[ 85, 1 ],
[ 86, 1 ],
[ 87, 0 ]
]
